<template>
  <div :class="[
    { 'as-tab-btn-center': isTabCenter },
    `as-parent-h2h as-parent-h2h-${siteName}`
  ]">
    <TabsBtn
      :tabs="tabs"
      :activeTab="activeTab"
      @change="changeTab"
      :isShowBorder="true"
    />

    <div
      class="as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup"
    >
      <div v-show="activeTab === 'vs'">
        <h2 class="as-h2-title-box">Các trận đối đầu</h2>
        <H2hTab
          :h2h="h2hVs"
          :teams="h2h.teams"
          :competitions="h2h.competitions"
          :match="match"
          tab="all"
          :homeTeamId="match.home_team_id"
          :key="activeTab"
        />
      </div>
      <div v-show="activeTab !== 'away'">
        <h2 class="as-h2-title-box">
          Các trận gần nhất: {{ match.home_team.name }}
        </h2>
        <H2hTab
          :h2h="h2hHome"
          :teams="h2h.teams"
          :competitions="h2h.competitions"
          :match="match"
          tab="home"
          :homeTeamId="match.home_team_id"
          :key="activeTab"
        />
      </div>
      <div v-show="activeTab !== 'home'">
        <h2 class="as-h2-title-box">
          Các trận gần nhất: {{ match.away_team.name }}
        </h2>
        <H2hTab
          :h2h="h2hAway"
          :teams="h2h.teams"
          :competitions="h2h.competitions"
          :match="match"
          tab="away"
          :homeTeamId="match.away_team_id"
          :key="activeTab"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { IH2h, IMatch } from "~src/interfaces";
import H2hTab from "~src/components/h2h/H2hTab.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  h2h: IH2h;
  match: IMatch;
  isTabCenter?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isTabCenter: false,
});

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("vs");

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: "Toàn bộ",
    key: "vs",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
};

const h2hVs = computed(() => {
  if (!props.h2h.vs || props.h2h.vs?.length === 0) return [];

  return props.h2h.vs.filter((item: any) => {
    if (activeTab.value === "home") {
      return props.match.home_team?.id === item[5][0];
    }
    if (activeTab.value === "away") {
      return props.match.home_team?.id === item[6][0];
    }

    return true;
  });
});

const h2hHome = computed(() => {
  if (!props.h2h.home || props.h2h.home?.length === 0) return [];

  return props.h2h.home.filter((item: any) => {
    let check = !props.h2h.vs.find((vsi: any) => item[0] === vsi[1]);
    if (check && activeTab.value === "home") {
      check = props.match.home_team?.id === item[5][0];
    }

    return check;
  });
});

const h2hAway = computed(() => {
  if (!props.h2h.away || props.h2h.away?.length === 0) return [];

  return props.h2h.away.filter((item: any) => {
    let check = !props.h2h.vs.find((vsi: any) => item[0] === vsi[1]);
    if (check && activeTab.value === "away") {
      check = props.match.away_team?.id === item[6][0];
    }

    return check;
  });
});
</script>

<script lang="ts">
export default {};
</script>
